import React from "react";
import Header from "../Header/Header";
import Footer from "../Footer/Footer";
import YouTube from "react-youtube";

const Commu = () => {
  const opts = {
    height: "490",
    width: "100%",
  };
  const listopts = {
    height: "89",
    width: "100%",
  };
  return (
    <div className="wrap main_wrap">
      <Header />
      <div className="commu_wrap">
        <div className="commu_banner_box">
          <div
            className="commu_banner animate__animated animate__fadeIn"
            style={{ animationDuration: "2s" }}
          ></div>
          <div className="banner_text_box">
            <div className="banner_title">커뮤니티</div>
            <div className="banner_text">방송출연 영상</div>
          </div>
        </div>
        <div className="section fifth_section">
          <div className="fifth_back">
            <div className="commu_title_box">
              <div className="commu_title">방송 출연 영상들</div>
            </div>
            <div className="fifth_content_box">
              <div className="fifth_video_back">
                <div className="video_box">
                  <YouTube
                    className="youtube_video"
                    opts={opts}
                    videoId={"maWnhAYIJgc"}
                  ></YouTube>
                </div>
                <div className="video_list_box">
                  <div className="video_row">
                    <div className="row_video_box">
                      <div className="video_box">
                        <YouTube
                          className="youtube_video"
                          opts={listopts}
                          videoId={"yEsbeqqA4rs"}
                        ></YouTube>
                      </div>
                    </div>
                    <div className="row_text_box">
                      <div className="row_title">
                        운동을 더많이할수록 키가 더 큰다?
                      </div>
                      <div className="row_text">키크니TV</div>
                    </div>
                  </div>
                  <div className="video_row">
                    <div className="row_video_box">
                      <div className="video_box">
                        <YouTube
                          className="youtube_video"
                          opts={listopts}
                          videoId={"R3OZKBVd-pE"}
                        ></YouTube>
                      </div>
                    </div>
                    <div className="row_text_box">
                      <div className="row_title">
                        키 성장을 위한 핵심 포인트
                      </div>
                      <div className="row_text">키크니TV</div>
                    </div>
                  </div>
                  <div className="video_row">
                    <div className="row_video_box">
                      <div className="video_box">
                        <YouTube
                          className="youtube_video"
                          opts={listopts}
                          videoId={"RqQnAvSATm0"}
                        ></YouTube>
                      </div>
                    </div>
                    <div className="row_text_box">
                      <div className="row_title">
                        먹는대로 다 키로 갈까요? 비만은 키성장을방해한다
                      </div>
                      <div className="row_text">키크니TV</div>
                    </div>
                  </div>
                  <div className="video_row">
                    <div className="row_video_box">
                      <div className="video_box">
                        <YouTube
                          className="youtube_video"
                          opts={listopts}
                          videoId={"SQ4aMhCojDM"}
                        ></YouTube>
                      </div>
                    </div>
                    <div className="row_text_box">
                      <div className="row_title">
                        키 성장 검사는 언제 시작하는 것이 좋은가요？
                      </div>
                      <div className="row_text">키크니TV</div>
                    </div>
                  </div>
                  <div className="video_row">
                    <div className="row_video_box">
                      <div className="video_box">
                        <YouTube
                          className="youtube_video"
                          opts={listopts}
                          videoId={"Gbiq_bNHnVw"}
                        ></YouTube>
                      </div>
                    </div>
                    <div className="row_text_box">
                      <div className="row_title">
                        사춘기가 빠르거나 성조숙증 시 반드시 주의해야 할 포인트
                        대한소아청소년과의사회 학술이사
                      </div>
                      <div className="row_text">키크니TV</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="fifth_bottom_box">
              <div className="bottom_text_box">
                대학병원부터 서울 첫 성장클리닉 개인 의원으로 시작하여 20여년의
                역사가 되어가고 있습니다. 소중한 임상 경험 및 전문 지식을
                바탕으로 더 정성스런 진료를 위해 노력하도록 하겠습니다.
              </div>
              <div className="bottom_btn_box">
                <div
                  className="bottom_btn"
                  onClick={() =>
                    window.open(
                      "https://youtube.com/@Kiumtv?si=DxftFuul2W62hO8G"
                    )
                  }
                >
                  채널로 이동
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default Commu;
